import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { isArray } from "lodash";
import Detail from "./detail";

function Details() {
  const { currentHd } = useSelector((state: any) => state.order);

  return (
    <Box
      sx={{
        width: "100%",
        py: 2,
        backgroundColor: "background.default",
      }}
    >
      <Container maxWidth="sm">
        <Stack
          gap={1}
          sx={{
            height: "calc(100vh - 60px - 1px - 32px - 48px - 48px - 45px)",
            overflow: "auto",
          }}
        >
          {!!currentHd &&
            isArray(currentHd?.details) &&
            currentHd?.details.map((item: any, index: number) => {
              return <Detail key={item._id} stt={index + 1} data={item} />;
            })}
        </Stack>
      </Container>
    </Box>
  );
}

export default Details;
